export class PasswordUpdateRequest {
  public userId: number = 0;
  public password: string = '';
  public newUser: boolean = false;
};